// src/views/profile.js

import React from 'react';

import { useAuth0, withAuthenticationRequired } from '@auth0/auth0-react';
import { Loading, ProfileForm, ProfileForm2 } from '../components';

const Profile = () => {
  const { user } = useAuth0();
  const { name, picture, email, role } = user;



  return (
    <div>
      <div className="flex flex-wrap items-center -mx-2">
        <div className="w-full md:w-1/6 px-2 mb-3">
          <img
            src={picture}
            alt="Profile"
            className="rounded-full w-full max-w-[150px] mb-3 md:mb-0"
          />
        </div>
        <div className="flex-1 px-2 text-center md:text-left">
          <h2>{name}</h2>
          <p className="text-lg text-neutral-500">{email}</p>
        </div>
      </div>
      <div className="flex flex-wrap -mx-2">
        <pre className="w-full px-2 text-white bg-neutral-900 p-4 rounded-lg">
          {JSON.stringify(user, null, 2)}
        </pre>
      </div>
      <ProfileForm/>

      <ProfileForm2/>
    </div>
  );
};

export default Profile;
